import { render, staticRenderFns } from "./FullscreenToggle.vue?vue&type=template&id=5a79f699&scoped=true&"
import script from "./FullscreenToggle.vue?vue&type=script&lang=js&"
export * from "./FullscreenToggle.vue?vue&type=script&lang=js&"
import style0 from "./FullscreenToggle.vue?vue&type=style&index=0&id=5a79f699&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a79f699",
  null
  
)

export default component.exports